import { hostname } from './urlParts';

export const makeGetPartnerPageUrl = pageName => `//${hostname}/gw/partners/public/v1/partner/${pageName}`;
export const makePartnersLandingPageUrl = () => `//${hostname}/partners`;
